import React, { useEffect, useState } from 'react'
import { TeamGQL, TeamStats } from '../../../../Api'
import { StatCol, StatRowStyle } from './styles'
import { mapTeamStat, ConvertDecimals, ConvertStatValue, getTeamColor } from '../../../../Utils'
import { Bar } from '../../../../Components/Bar/Bar'
import { STATS_YEAR } from '../../../../Config/League/league.config'

type StatRowProps = {
  year: number
  statName: string
  homeTeam: TeamGQL
  awayTeam: TeamGQL
  seasonSegement?: string
}

export const StatRow: React.FC<React.PropsWithChildren<StatRowProps>> = ({
  year,
  statName,
  awayTeam,
  homeTeam,
  seasonSegement,
}) => {
  const [awayTeamStat, setAwayTeamStat] = useState<number>(0)
  const [awayStatString, setAwayStatString] = useState<string | number>('')

  const [homeTeamStat, setHomeTeamStat] = useState<number>(0)
  const [homeStatString, setHomeStatString] = useState<string | number>('')

  useEffect(() => {
    convertStats()
  }, [])

  const convertStats = () => {
    let awayStat: number = 0
    let homeStat: number = 0
    if (seasonSegement === 'champseries') {
      awayStat = awayTeam.champSeries?.stats
        ? (awayTeam.champSeries?.stats[statName as keyof TeamStats] as number)
        : 0
      setAwayTeamStat(ConvertDecimals(awayStat, statName))
      setAwayStatString(ConvertStatValue(awayStat, statName))

      homeStat = homeTeam.champSeries?.stats
        ? (homeTeam.champSeries?.stats[statName as keyof TeamStats] as number)
        : 0
      setHomeTeamStat(ConvertDecimals(homeStat, statName))
      setHomeStatString(ConvertStatValue(homeStat, statName))
      return
    }
    //All other cases
    awayStat = awayTeam.stats
      ? (awayTeam.stats[statName as keyof TeamStats] as number)
      : 0
    setAwayTeamStat(ConvertDecimals(awayStat, statName))
    setAwayStatString(ConvertStatValue(awayStat, statName))

    homeStat = homeTeam.stats
      ? (homeTeam.stats[statName as keyof TeamStats] as number)
      : 0
    setHomeTeamStat(ConvertDecimals(homeStat, statName))
    setHomeStatString(ConvertStatValue(homeStat, statName))
    return
  }
  const total = (awayTeamStat || 1) + (homeTeamStat || 1)

  return (
    <StatRowStyle>
      <StatCol order={1}>
        <div className='statItem'>
          {awayStatString || `No ${year || STATS_YEAR} PLL stats`}
        </div>
        <Bar
          side="left"
          fillColor={getTeamColor(awayTeam.officialId)}
          filledWidth={awayTeamStat}
          totalWidth={total}
          
        />
      </StatCol>
      <StatCol order={2}>
        <div className='statText'>{mapTeamStat(statName)}</div>
      </StatCol>
      <StatCol order={3}>
        <div className='statItem'>
          {homeStatString || `No ${year || STATS_YEAR} PLL stats`}
        </div>
        <Bar
          side="right"
          fillColor={getTeamColor(homeTeam.officialId)}
          filledWidth={homeTeamStat}
          totalWidth={total}
        />
      </StatCol>
    </StatRowStyle>
  )
}
